// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Privacy Policy Page Styles ── */

.privacy_policy {
  padding-top: 10px;
  padding-bottom: 80px;
  font-family: "Inter", sans-serif;
  color: #1e293b;
}

body.light_theme .privacy_policy {
  color: #1e293b;
}

.agcex-pp-hero {
  text-align: center;
  margin-bottom: 30px;
}

.agcex-pp-hero h1 {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 6px;
}

.agcex-pp-hero .agcex-pp-subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #ececec;
  margin-bottom: 4px;
}

body.light_theme .agcex-pp-hero .agcex-pp-subtitle {
  color: #64748b;
}

.agcex-pp-hero .agcex-pp-company {
  font-size: 15px;
  font-weight: 700;
  color: #e9e9e9;
}


body.light_theme .agcex-pp-hero .agcex-pp-company {
  color: #475569;
}

.agcex-pp-hero .agcex-pp-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 12px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.agcex-pp-hero .agcex-pp-meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-align: left;
}

.agcex-pp-card {
  background: #ffffff0f;
  border: 1px solid #e2e8f012;
  border-radius: 16px;
  padding: 40px 32px;
  max-width: 90%;
  margin: 0 auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
}

body.light_theme .agcex-pp-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

@media (max-width: 767px) {

  .agcex-pp-card {
    padding: 24px 18px;
    border-radius: 12px;
    max-width: 100%;
  }

  .agcex-pp-hero h1 {
    font-size: 24px;
  }

  .agcex-pp-hero .agcex-pp-meta {
    flex-wrap: wrap;
    gap: 12px;
  }
}

/* Summary Table */
.agcex-pp-summary-table-wrapper {
  margin-bottom: 30px;
  overflow-x: auto;
  border: 1px solid #e2e8f00f;
  border-radius: 12px;
  background: #f8fafc08;
}

body.light_theme .agcex-pp-summary-table-wrapper {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.agcex-pp-summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agcex-pp-summary-table tr {
  border-bottom: 1px solid #e2e8f014;
}

body.light_theme .agcex-pp-summary-table tr {
  border-bottom: 1px solid #e2e8f0;
}

.agcex-pp-summary-table tr:last-child {
  border-bottom: none;
}

.agcex-pp-summary-table .agcex-pp-label {
  font-weight: 600;
  color: #e5e5e5;
  border-right: 1px solid #e2e8f012;
  padding: 14px 20px;
  width: 280px;
}

body.light_theme .agcex-pp-summary-table .agcex-pp-label {
  color: #0f172a;
  border-right: 1px solid #e2e8f0;
}

.agcex-pp-summary-table .agcex-pp-value {
  color: #f0f0f0;
  padding: 14px 20px;
}

body.light_theme .agcex-pp-summary-table .agcex-pp-value {
  color: #475569;
}

.agcex-pp-summary-table .agcex-pp-value a {
  color: #ce9f4e;
  text-decoration: none;
  font-weight: 500;
}

.agcex-pp-summary-table .agcex-pp-value a:hover {
  text-decoration: underline;
}

@media (max-width: 575px) {
  .agcex-pp-summary-table .agcex-pp-label {
    width: 140px;
    padding: 12px 14px;
    font-size: 13px;
  }

  .agcex-pp-summary-table .agcex-pp-value {
    padding: 12px 14px;
    font-size: 13px;
  }
}

/* Intro Box */
.agcex-pp-intro-box {
  background: #f8fafc0a;
  border: 1px solid #cbd5e114;
  border-radius: 12px;
  padding: 22px 26px;
  margin-bottom: 36px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

body.light_theme .agcex-pp-intro-box {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}

.agcex-pp-intro-box p {
  font-size: 14px;
  line-height: 1.8;
  color: #eeeeee;
  margin: 0;
}

body.light_theme .agcex-pp-intro-box p {
  color: #334155;
}

/* Sections */
.agcex-pp-section {
  margin-bottom: 36px;
}

.agcex-pp-section:last-child {
  margin-bottom: 0;
}

.agcex-pp-section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: linear-gradient(135deg, #d1aa67, #f5c573);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}

.agcex-pp-section h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #ededed;
  border-bottom: 1px solid #e2e8f01f;
  margin: 0 0 18px;
  padding-bottom: 12px;
}

body.light_theme .agcex-pp-section h2 {
  color: #0f172a;
  border-bottom: 1px solid #e2e8f0;
}

.agcex-pp-section p {
  font-size: 14.5px;
  line-height: 1.75;
  color: #d9d9d9;
  margin: 0 0 16px;
}

body.light_theme .agcex-pp-section p {
  color: #475569;
}

.agcex-pp-section p:last-child {
  margin-bottom: 0;
}

.agcex-pp-text-list p {
  margin-bottom: 18px;
  padding-left: 12px;
  border-left: 3px solid #e2e8f0;
}

.agcex-pp-text-list p strong {
  color: #ffffff;
}

body.light_theme .agcex-pp-text-list p strong {
  color: #0f172a;
}

.agcex-pp-section ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.agcex-pp-section ul li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 10px;
  font-size: 14.5px;
  line-height: 1.7;
  color: #f7f7f7;
}

body.light_theme .agcex-pp-section ul li {
  color: #475569;
}

.agcex-pp-section p a {
  color: #ce9f4e;
}

.agcex-pp-section ul li strong {
  color: #ffffff;
}

body.light_theme .agcex-pp-section ul li strong {
  color: #0f172a;
}

.agcex-pp-section ul li::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: linear-gradient(135deg, #dbb26a, #f1c171);
}

/* Sub Articles */
.agcex-pp-sub-article {
  margin-top: 24px;
  margin-bottom: 24px;
  padding-left: 16px;
  border-left: 2px solid #cbd5e126;
}

body.light_theme .agcex-pp-sub-article {
  border-left: 2px solid #cbd5e1;
}

.agcex-pp-sub-article h3 {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 10px;
}

body.light_theme .agcex-pp-sub-article h3 {
  color: #0f172a;
}

/* Purpose Table */
.agcex-pp-table-responsive {
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #e2e8f026;
  border-radius: 12px;
}

body.light_theme .agcex-pp-table-responsive {
  border: 1px solid #e2e8f0;
}

.agcex-pp-purpose-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agcex-pp-purpose-table th,
.agcex-pp-purpose-table td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #e2e8f01f;
  line-height: 1.6;
}

body.light_theme .agcex-pp-purpose-table th,
body.light_theme .agcex-pp-purpose-table td {
  border-bottom: 1px solid #e2e8f0;
}

.agcex-pp-purpose-table th {
  background: #f8fafc12;
  font-weight: 700;
  color: #e1e1e1;
  font-size: 14px;
  border-bottom: 2px solid #e2e8f00d;

}

body.light_theme .agcex-pp-purpose-table th {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  color: #0d111a;
}

.agcex-pp-purpose-table td {
  color: #ececec;
}

body.light_theme .agcex-pp-purpose-table td {
  color: #475569;
}

.agcex-pp-purpose-table tr:last-child td {
  border-bottom: none;
}

.agcex-pp-purpose-table tr:nth-child(even) {
  background-color: #fdfdfd0d;
}

body.light_theme .agcex-pp-purpose-table tr:nth-child(even) {
  background-color: #fcfcfd;
}

.agcex-pp-purpose-table td strong {
  color: #f1f1f1;
}

body.light_theme .agcex-pp-purpose-table td strong {
  color: #0f172a;
}

/* Contact Box & Table Wrapper */
.agcex-pp-contact-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px 28px;
  margin-top: 28px;
}

.agcex-pp-contact-box h3 {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px;
}

.agcex-pp-contact-box p {
  font-size: 14px;
  margin-bottom: 16px;
}

.agcex-pp-email-highlight {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
}

.agcex-pp-email-highlight i {
  color: #ce9f4e;
  font-size: 18px;
}

.agcex-pp-email-highlight a {
  color: #ce9f4e;
  text-decoration: none;
}

.agcex-pp-email-highlight a:hover {
  text-decoration: underline;
}

.agcex-pp-contact-table-wrapper {
  margin-top: 20px;
  margin-bottom: 24px;
}

/* Confirmation Divider & Text */
.agcex-pp-divider {
  border: 0;
  height: 1px;
  background: #e2e8f0;
  margin: 40px 0 24px;
}

.agcex-pp-confirmation-text {
  font-size: 15px;
  line-height: 1.7;
  color: #f0f0f0;
  margin-bottom: 36px;
}


body.light_theme .agcex-pp-confirmation-text {
  color: #334155;
}

/* Footer Grid */
.agcex-pp-footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #f8fafc12;
  border: 1px solid #cbd5e112;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
}

body.light_theme .agcex-pp-footer-grid {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}

.agcex-pp-footer-col {
  padding: 20px 24px;
  border-right: 1px solid #cbd5e1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agcex-pp-footer-col:last-child {
  border-right: none;
}

.agcex-pp-footer-col strong {
  font-size: 14px;
  font-weight: 700;
  color: #f3f3f3;
  margin-bottom: 4px;
}

body.light_theme .agcex-pp-footer-col strong {
  color: #0f172a;
}

.agcex-pp-footer-col span {
  font-size: 13.5px;
  color: #eeeeee;
  line-height: 1.5;
}

body.light_theme .agcex-pp-footer-col span {
  color: #475569;
}

.agcex-pp-footer-col span a {
  color: #ce9f4e;
  text-decoration: none;
}

.agcex-pp-footer-col span a:hover {
  text-decoration: underline;
}

/* Copyright Statement */
.agcex-pp-copyright {
  text-align: center;
  font-size: 13px;
  color: #e3e3e3;
  padding-top: 20px;
  border-top: 1px solid #e2e8f014;
}

body.light_theme .agcex-pp-copyright {
  color: #64748b;
  border-top: 1px solid #e2e8f0;
}

/* Footer Note */
.agcex-pp-footer-note {
  margin-top: 30px;
  font-size: 13px;
  color: #94a3b8;
  text-align: center;
  line-height: 1.7;
  display: none;
  /* Replaced by the clean bottom grid & copyright */
}

@media (max-width: 991px) {
  .privacy_policy {
    padding-top: 20px;
  }

  .agcex-pp-section h2 {
    font-size: 18px;
  }

  .agcex-pp-footer-grid {
    grid-template-columns: 1fr;
  }

  .agcex-pp-footer-col {
    border-right: none;
    border-bottom: 1px solid #cbd5e1;
  }

  .agcex-pp-footer-col:last-child {
    border-bottom: none;
  }
}

@media (max-width: 767px) {

      .agcex-pp-section h2 {
        font-size: 16px;
    }
  }

@media (max-width: 480px) {
  .agcex-pp-contact-box {
    padding: 18px 20px;
  }

  .agcex-pp-email-highlight {
    font-size: 14px;
    padding: 8px 16px;
  }
}

/* Additional Helper Classes for Policy Pages */
.agcex-pp-title-uppercase {
  font-size: 28px;
  text-transform: uppercase;
}

.agcex-pp-company-subtitle {
  font-size: 16px;
  font-weight: 600;
}

.agcex-pp-license-detail {
  font-size: 13.5px;
  line-height: 1.6;
}

.agcex-pp-license-detail-sm {
  font-size: 14px;
}

.agcex-pp-card-subtitle {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-color, #ffffff);
  margin-bottom: 1rem;
}

body.light_theme .agcex-pp-card-subtitle {
  color: #0f172a;
}

.agcex-pp-gov-row-head {
  background: rgba(248, 250, 252, 0.08);
}

body.light_theme .agcex-pp-gov-row-head {
  background: #f8fafc;
}

.agcex-pp-gov-th {
  padding: 12px 18px;
  color: #d1aa67;
  font-weight: 700;
}

.agcex-pp-disclaimer-text {
  font-size: 12.5px;
}

.agcex-pp-term-col {
  width: 200px;
}

.agcex-pp-term-col-wide {
  width: 220px;
}

.agcex-pp-appendix-note {
  font-size: 13px;
  color: #94a3b8;
}

.agcex-pp-appendix-note-sm {
  font-size: 12.5px;
  color: #94a3b8;
}

.agcex-pp-numbered-list {
  padding-left: 20px;
  color: #e0e0e0;
  font-size: 14.5px;
  line-height: 1.8;
}

body.light_theme .agcex-pp-numbered-list {
  color: #475569;
}

.agcex-pp-declaration-box {
  font-style: italic;
  background: rgba(248, 250, 252, 0.05);
  padding: 14px 18px;
  border-radius: 8px;
}

body.light_theme .agcex-pp-declaration-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.agcex-pp-legal-note {
  font-size: 13px;
  color: #94a3b8;
}

/* Grid & Matrix Bordered Table Styling */
.agcex-pp-bordered-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid rgba(226, 232, 240, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

body.light_theme .agcex-pp-bordered-table {
  border: 1px solid #cbd5e1;
}

.agcex-pp-bordered-table th {
  background: rgba(209, 170, 103, 0.12);
  color: #f3f4f6;
  font-weight: 700;
  padding: 12px 16px;
  text-align: left;
  border: 1px solid rgba(226, 232, 240, 0.18);
  border-bottom: 2px solid rgba(209, 170, 103, 0.4);
}

body.light_theme .agcex-pp-bordered-table th {
  background: #f1f5f9;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  border-bottom: 2px solid #ce9f4e;
}

.agcex-pp-bordered-table td {
  padding: 12px 16px;
  color: #e2e8f0;
  border: 1px solid rgba(226, 232, 240, 0.15);
  line-height: 1.6;
  vertical-align: middle;
}

body.light_theme .agcex-pp-bordered-table td {
  color: #334155;
  border: 1px solid #cbd5e1;
}

.agcex-pp-bordered-table td[rowSpan],
.agcex-pp-bordered-table td[rowspan] {
  background: rgba(248, 250, 252, 0.05);
  font-weight: 600;
  color: #ffffff;
  vertical-align: middle;
  border-right: 2px solid rgba(209, 170, 103, 0.4);
}

body.light_theme .agcex-pp-bordered-table td[rowSpan],
body.light_theme .agcex-pp-bordered-table td[rowspan] {
  background: #f8fafc;
  color: #0f172a;
  border-right: 2px solid #ce9f4e;
}

.agcex-pp-bordered-table tr:hover td {
  background-color: rgba(255, 255, 255, 0.03);
}

body.light_theme .agcex-pp-bordered-table tr:hover td {
  background-color: #f8fafc;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/PrivacyPolicy/privacy-policy.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;;AAEpC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;MAEM;QACE,eAAe;IACnB;EACF;;AAEF;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ── Privacy Policy Page Styles ── */\r\n\r\n.privacy_policy {\r\n  padding-top: 10px;\r\n  padding-bottom: 80px;\r\n  font-family: \"Inter\", sans-serif;\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light_theme .privacy_policy {\r\n  color: #1e293b;\r\n}\r\n\r\n.agcex-pp-hero {\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.agcex-pp-hero h1 {\r\n  font-size: 32px;\r\n  font-weight: 800;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.agcex-pp-hero .agcex-pp-subtitle {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #ececec;\r\n  margin-bottom: 4px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-hero .agcex-pp-subtitle {\r\n  color: #64748b;\r\n}\r\n\r\n.agcex-pp-hero .agcex-pp-company {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #e9e9e9;\r\n}\r\n\r\n\r\nbody.light_theme .agcex-pp-hero .agcex-pp-company {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-hero .agcex-pp-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 24px;\r\n  margin-top: 12px;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  font-weight: 500;\r\n}\r\n\r\n.agcex-pp-hero .agcex-pp-meta span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  text-align: left;\r\n}\r\n\r\n.agcex-pp-card {\r\n  background: #ffffff0f;\r\n  border: 1px solid #e2e8f012;\r\n  border-radius: 16px;\r\n  padding: 40px 32px;\r\n  max-width: 90%;\r\n  margin: 0 auto;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\nbody.light_theme .agcex-pp-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n  .agcex-pp-card {\r\n    padding: 24px 18px;\r\n    border-radius: 12px;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .agcex-pp-hero h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .agcex-pp-hero .agcex-pp-meta {\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n  }\r\n}\r\n\r\n/* Summary Table */\r\n.agcex-pp-summary-table-wrapper {\r\n  margin-bottom: 30px;\r\n  overflow-x: auto;\r\n  border: 1px solid #e2e8f00f;\r\n  border-radius: 12px;\r\n  background: #f8fafc08;\r\n}\r\n\r\nbody.light_theme .agcex-pp-summary-table-wrapper {\r\n  border: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n}\r\n\r\n.agcex-pp-summary-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.agcex-pp-summary-table tr {\r\n  border-bottom: 1px solid #e2e8f014;\r\n}\r\n\r\nbody.light_theme .agcex-pp-summary-table tr {\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-summary-table tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.agcex-pp-summary-table .agcex-pp-label {\r\n  font-weight: 600;\r\n  color: #e5e5e5;\r\n  border-right: 1px solid #e2e8f012;\r\n  padding: 14px 20px;\r\n  width: 280px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-summary-table .agcex-pp-label {\r\n  color: #0f172a;\r\n  border-right: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-summary-table .agcex-pp-value {\r\n  color: #f0f0f0;\r\n  padding: 14px 20px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-summary-table .agcex-pp-value {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-summary-table .agcex-pp-value a {\r\n  color: #ce9f4e;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.agcex-pp-summary-table .agcex-pp-value a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .agcex-pp-summary-table .agcex-pp-label {\r\n    width: 140px;\r\n    padding: 12px 14px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .agcex-pp-summary-table .agcex-pp-value {\r\n    padding: 12px 14px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* Intro Box */\r\n.agcex-pp-intro-box {\r\n  background: #f8fafc0a;\r\n  border: 1px solid #cbd5e114;\r\n  border-radius: 12px;\r\n  padding: 22px 26px;\r\n  margin-bottom: 36px;\r\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\nbody.light_theme .agcex-pp-intro-box {\r\n  background: #f8fafc;\r\n  border: 1px solid #cbd5e1;\r\n}\r\n\r\n.agcex-pp-intro-box p {\r\n  font-size: 14px;\r\n  line-height: 1.8;\r\n  color: #eeeeee;\r\n  margin: 0;\r\n}\r\n\r\nbody.light_theme .agcex-pp-intro-box p {\r\n  color: #334155;\r\n}\r\n\r\n/* Sections */\r\n.agcex-pp-section {\r\n  margin-bottom: 36px;\r\n}\r\n\r\n.agcex-pp-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.agcex-pp-section-number {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  background: linear-gradient(135deg, #d1aa67, #f5c573);\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  margin-right: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.agcex-pp-section h2 {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #ededed;\r\n  border-bottom: 1px solid #e2e8f01f;\r\n  margin: 0 0 18px;\r\n  padding-bottom: 12px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-section h2 {\r\n  color: #0f172a;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-section p {\r\n  font-size: 14.5px;\r\n  line-height: 1.75;\r\n  color: #d9d9d9;\r\n  margin: 0 0 16px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-section p {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-section p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.agcex-pp-text-list p {\r\n  margin-bottom: 18px;\r\n  padding-left: 12px;\r\n  border-left: 3px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-text-list p strong {\r\n  color: #ffffff;\r\n}\r\n\r\nbody.light_theme .agcex-pp-text-list p strong {\r\n  color: #0f172a;\r\n}\r\n\r\n.agcex-pp-section ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 20px;\r\n}\r\n\r\n.agcex-pp-section ul li {\r\n  position: relative;\r\n  padding-left: 24px;\r\n  margin-bottom: 10px;\r\n  font-size: 14.5px;\r\n  line-height: 1.7;\r\n  color: #f7f7f7;\r\n}\r\n\r\nbody.light_theme .agcex-pp-section ul li {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-section p a {\r\n  color: #ce9f4e;\r\n}\r\n\r\n.agcex-pp-section ul li strong {\r\n  color: #ffffff;\r\n}\r\n\r\nbody.light_theme .agcex-pp-section ul li strong {\r\n  color: #0f172a;\r\n}\r\n\r\n.agcex-pp-section ul li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 4px;\r\n  top: 10px;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #dbb26a, #f1c171);\r\n}\r\n\r\n/* Sub Articles */\r\n.agcex-pp-sub-article {\r\n  margin-top: 24px;\r\n  margin-bottom: 24px;\r\n  padding-left: 16px;\r\n  border-left: 2px solid #cbd5e126;\r\n}\r\n\r\nbody.light_theme .agcex-pp-sub-article {\r\n  border-left: 2px solid #cbd5e1;\r\n}\r\n\r\n.agcex-pp-sub-article h3 {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  margin: 0 0 10px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-sub-article h3 {\r\n  color: #0f172a;\r\n}\r\n\r\n/* Purpose Table */\r\n.agcex-pp-table-responsive {\r\n  overflow-x: auto;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #e2e8f026;\r\n  border-radius: 12px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-table-responsive {\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-purpose-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.agcex-pp-purpose-table th,\r\n.agcex-pp-purpose-table td {\r\n  padding: 14px 18px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #e2e8f01f;\r\n  line-height: 1.6;\r\n}\r\n\r\nbody.light_theme .agcex-pp-purpose-table th,\r\nbody.light_theme .agcex-pp-purpose-table td {\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-purpose-table th {\r\n  background: #f8fafc12;\r\n  font-weight: 700;\r\n  color: #e1e1e1;\r\n  font-size: 14px;\r\n  border-bottom: 2px solid #e2e8f00d;\r\n\r\n}\r\n\r\nbody.light_theme .agcex-pp-purpose-table th {\r\n  background: #f8fafc;\r\n  border-bottom: 2px solid #e2e8f0;\r\n  color: #0d111a;\r\n}\r\n\r\n.agcex-pp-purpose-table td {\r\n  color: #ececec;\r\n}\r\n\r\nbody.light_theme .agcex-pp-purpose-table td {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-purpose-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.agcex-pp-purpose-table tr:nth-child(even) {\r\n  background-color: #fdfdfd0d;\r\n}\r\n\r\nbody.light_theme .agcex-pp-purpose-table tr:nth-child(even) {\r\n  background-color: #fcfcfd;\r\n}\r\n\r\n.agcex-pp-purpose-table td strong {\r\n  color: #f1f1f1;\r\n}\r\n\r\nbody.light_theme .agcex-pp-purpose-table td strong {\r\n  color: #0f172a;\r\n}\r\n\r\n/* Contact Box & Table Wrapper */\r\n.agcex-pp-contact-box {\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 24px 28px;\r\n  margin-top: 28px;\r\n}\r\n\r\n.agcex-pp-contact-box h3 {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.agcex-pp-contact-box p {\r\n  font-size: 14px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.agcex-pp-email-highlight {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background: #ffffff;\r\n  border: 1px solid #cbd5e1;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n}\r\n\r\n.agcex-pp-email-highlight i {\r\n  color: #ce9f4e;\r\n  font-size: 18px;\r\n}\r\n\r\n.agcex-pp-email-highlight a {\r\n  color: #ce9f4e;\r\n  text-decoration: none;\r\n}\r\n\r\n.agcex-pp-email-highlight a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.agcex-pp-contact-table-wrapper {\r\n  margin-top: 20px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Confirmation Divider & Text */\r\n.agcex-pp-divider {\r\n  border: 0;\r\n  height: 1px;\r\n  background: #e2e8f0;\r\n  margin: 40px 0 24px;\r\n}\r\n\r\n.agcex-pp-confirmation-text {\r\n  font-size: 15px;\r\n  line-height: 1.7;\r\n  color: #f0f0f0;\r\n  margin-bottom: 36px;\r\n}\r\n\r\n\r\nbody.light_theme .agcex-pp-confirmation-text {\r\n  color: #334155;\r\n}\r\n\r\n/* Footer Grid */\r\n.agcex-pp-footer-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  background: #f8fafc12;\r\n  border: 1px solid #cbd5e112;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  margin-bottom: 24px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-footer-grid {\r\n  background: #f8fafc;\r\n  border: 1px solid #cbd5e1;\r\n}\r\n\r\n.agcex-pp-footer-col {\r\n  padding: 20px 24px;\r\n  border-right: 1px solid #cbd5e1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.agcex-pp-footer-col:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.agcex-pp-footer-col strong {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #f3f3f3;\r\n  margin-bottom: 4px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-footer-col strong {\r\n  color: #0f172a;\r\n}\r\n\r\n.agcex-pp-footer-col span {\r\n  font-size: 13.5px;\r\n  color: #eeeeee;\r\n  line-height: 1.5;\r\n}\r\n\r\nbody.light_theme .agcex-pp-footer-col span {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-footer-col span a {\r\n  color: #ce9f4e;\r\n  text-decoration: none;\r\n}\r\n\r\n.agcex-pp-footer-col span a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Copyright Statement */\r\n.agcex-pp-copyright {\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #e3e3e3;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #e2e8f014;\r\n}\r\n\r\nbody.light_theme .agcex-pp-copyright {\r\n  color: #64748b;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n/* Footer Note */\r\n.agcex-pp-footer-note {\r\n  margin-top: 30px;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  text-align: center;\r\n  line-height: 1.7;\r\n  display: none;\r\n  /* Replaced by the clean bottom grid & copyright */\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .privacy_policy {\r\n    padding-top: 20px;\r\n  }\r\n\r\n  .agcex-pp-section h2 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .agcex-pp-footer-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .agcex-pp-footer-col {\r\n    border-right: none;\r\n    border-bottom: 1px solid #cbd5e1;\r\n  }\r\n\r\n  .agcex-pp-footer-col:last-child {\r\n    border-bottom: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n      .agcex-pp-section h2 {\r\n        font-size: 16px;\r\n    }\r\n  }\r\n\r\n@media (max-width: 480px) {\r\n  .agcex-pp-contact-box {\r\n    padding: 18px 20px;\r\n  }\r\n\r\n  .agcex-pp-email-highlight {\r\n    font-size: 14px;\r\n    padding: 8px 16px;\r\n  }\r\n}\r\n\r\n/* Additional Helper Classes for Policy Pages */\r\n.agcex-pp-title-uppercase {\r\n  font-size: 28px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.agcex-pp-company-subtitle {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.agcex-pp-license-detail {\r\n  font-size: 13.5px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.agcex-pp-license-detail-sm {\r\n  font-size: 14px;\r\n}\r\n\r\n.agcex-pp-card-subtitle {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: var(--text-color, #ffffff);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nbody.light_theme .agcex-pp-card-subtitle {\r\n  color: #0f172a;\r\n}\r\n\r\n.agcex-pp-gov-row-head {\r\n  background: rgba(248, 250, 252, 0.08);\r\n}\r\n\r\nbody.light_theme .agcex-pp-gov-row-head {\r\n  background: #f8fafc;\r\n}\r\n\r\n.agcex-pp-gov-th {\r\n  padding: 12px 18px;\r\n  color: #d1aa67;\r\n  font-weight: 700;\r\n}\r\n\r\n.agcex-pp-disclaimer-text {\r\n  font-size: 12.5px;\r\n}\r\n\r\n.agcex-pp-term-col {\r\n  width: 200px;\r\n}\r\n\r\n.agcex-pp-term-col-wide {\r\n  width: 220px;\r\n}\r\n\r\n.agcex-pp-appendix-note {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.agcex-pp-appendix-note-sm {\r\n  font-size: 12.5px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.agcex-pp-numbered-list {\r\n  padding-left: 20px;\r\n  color: #e0e0e0;\r\n  font-size: 14.5px;\r\n  line-height: 1.8;\r\n}\r\n\r\nbody.light_theme .agcex-pp-numbered-list {\r\n  color: #475569;\r\n}\r\n\r\n.agcex-pp-declaration-box {\r\n  font-style: italic;\r\n  background: rgba(248, 250, 252, 0.05);\r\n  padding: 14px 18px;\r\n  border-radius: 8px;\r\n}\r\n\r\nbody.light_theme .agcex-pp-declaration-box {\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.agcex-pp-legal-note {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n/* Grid & Matrix Bordered Table Styling */\r\n.agcex-pp-bordered-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n  border: 1px solid rgba(226, 232, 240, 0.2);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\nbody.light_theme .agcex-pp-bordered-table {\r\n  border: 1px solid #cbd5e1;\r\n}\r\n\r\n.agcex-pp-bordered-table th {\r\n  background: rgba(209, 170, 103, 0.12);\r\n  color: #f3f4f6;\r\n  font-weight: 700;\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  border: 1px solid rgba(226, 232, 240, 0.18);\r\n  border-bottom: 2px solid rgba(209, 170, 103, 0.4);\r\n}\r\n\r\nbody.light_theme .agcex-pp-bordered-table th {\r\n  background: #f1f5f9;\r\n  color: #0f172a;\r\n  border: 1px solid #cbd5e1;\r\n  border-bottom: 2px solid #ce9f4e;\r\n}\r\n\r\n.agcex-pp-bordered-table td {\r\n  padding: 12px 16px;\r\n  color: #e2e8f0;\r\n  border: 1px solid rgba(226, 232, 240, 0.15);\r\n  line-height: 1.6;\r\n  vertical-align: middle;\r\n}\r\n\r\nbody.light_theme .agcex-pp-bordered-table td {\r\n  color: #334155;\r\n  border: 1px solid #cbd5e1;\r\n}\r\n\r\n.agcex-pp-bordered-table td[rowSpan],\r\n.agcex-pp-bordered-table td[rowspan] {\r\n  background: rgba(248, 250, 252, 0.05);\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  vertical-align: middle;\r\n  border-right: 2px solid rgba(209, 170, 103, 0.4);\r\n}\r\n\r\nbody.light_theme .agcex-pp-bordered-table td[rowSpan],\r\nbody.light_theme .agcex-pp-bordered-table td[rowspan] {\r\n  background: #f8fafc;\r\n  color: #0f172a;\r\n  border-right: 2px solid #ce9f4e;\r\n}\r\n\r\n.agcex-pp-bordered-table tr:hover td {\r\n  background-color: rgba(255, 255, 255, 0.03);\r\n}\r\n\r\nbody.light_theme .agcex-pp-bordered-table tr:hover td {\r\n  background-color: #f8fafc;\r\n}\r\n\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
